import { resolveBackTarget } from '@/utils/helpers'

export default [
  {
    path: '/u/:username/collections',
    components: {
      default: () => import('@/views/PublicCollections/PublicCollections.vue'),
      appbar: () => import('@/views/PublicCollections/components/PublicRouteAppBar.vue'),
      footer: () => import('@/components/AppFooterExpandable.vue'),
    },
    props: {
      footer: {
        expandable: true,
      },
    },
    meta: {
      appbarVisibility: true,
      footerVisibility: ({ isMobile }) => !isMobile,
      requiresAuth: false,
      skipOnboarding: true,
      isPublicRoute: true,
      transition: 't-fade',
      layoutTransition: 't-fade',
      systemBar: {
        color: 'neutral0',
      },
    },
  },
  {
    path: '/u/:username/collections/:id',
    components: {
      default: () => import('@/views/PublicCollections/PublicCollection.vue'),
      sidebar: () => import('@/views/Collections/components/CollectionSidebar.vue'),
      appbar: () => import('@/views/PublicCollections/components/PublicRouteAppBar.vue'),
      footer: () => import('@/components/AppFooterExpandable.vue'),
    },
    props: {
      footer: {
        expandable: true,
      },
    },
    meta: {
      sidebarVisibility() {
        return true
      },
      appbarVisibility: true,
      footerVisibility: ({ isMobile }) => !isMobile,
      requiresAuth: false,
      skipOnboarding: true,
      isPublicRoute: true,
      transition: 't-fade',
      layoutTransition: 't-fade',
      systemBar: {
        color: 'neutral0',
      },
    },
  },
  // Note detail in public collection
  {
    path: '/u/:username/collections/:id/notes/:noteId',
    component: () => import('@/views/PublicCollections/PublicNoteDetail.vue'),
    meta: {
      requiresAuth: false,
      skipOnboarding: true,
      isPublicRoute: true,
      layout: 'focus-detail',
      transition: 't-fade',
      layoutTransition: 't-fade',
      systemBar: {
        color: 'neutral0',
      },
      layoutProps: {
        backButton: {
          to: from => `/u/${from.params.username}/collections/${from.params.id}`,
        },
      },
    },
  },
  // Bookmark detail in public collection
  {
    path: '/u/:username/collections/:id/bookmarks/:bookmarkId',
    component: () => import('@/views/PublicCollections/PublicBookmarkDetail.vue'),
    meta: {
      requiresAuth: false,
      skipOnboarding: true,
      isPublicRoute: true,
      layout: 'focus-detail',
      transition: 't-fade',
      layoutTransition: 't-fade',
      systemBar: {
        color: 'neutral0',
      },
      layoutProps: {
        backButton: {
          to: from => `/u/${from.params.username}/collections/${from.params.id}`,
        },
      },
    },
  },
  // Item comments in public collection
  {
    path: '/u/:username/collections/:id/items/:itemId/comments',
    components: {
      default: () => import('@/views/PublicCollections/PublicItemComments.vue'),
      appbar: () => import('@/views/PublicCollections/components/PublicRouteAppBar.vue'),
    },
    meta: {
      appbarVisibility: true,
      requiresAuth: false,
      skipOnboarding: true,
      isPublicRoute: true,
      layout: 'focus',
      transition: 't-fade',
      layoutTransition: 't-fade',
      systemBar: {
        color: 'neutral0',
      },
      layoutProps: {
        backButton: {
          to: from => `/u/${from.params.username}/collections/${from.params.id}`,
        },
      },
    },
  },
  // Item likes in public collection
  {
    path: '/u/:username/collections/:id/items/:itemId/likes',
    components: {
      default: () => import('@/views/PublicCollections/PublicItemLikes.vue'),
      appbar: () => import('@/views/PublicCollections/components/PublicRouteAppBar.vue'),
    },
    meta: {
      appbarVisibility: true,
      requiresAuth: false,
      skipOnboarding: true,
      isPublicRoute: true,
      layout: 'focus',
      transition: 't-fade',
      layoutTransition: 't-fade',
      systemBar: {
        color: 'neutral0',
      },
      layoutProps: {
        backButton: {
          to: route => resolveBackTarget(
            route,
            `/u/${route.params.username}/collections/${route.params.id}`,
          ),
        },
      },
    },
  },
  // Add item to collections from public collection
  {
    path: '/u/:username/collections/:id/items/:itemId/add-collections',
    component: () => import('@/views/PublicCollections/PublicAddToCollections.vue'),
    meta: {
      requiresAuth: true,
      skipOnboarding: true,
      isPublicRoute: true,
      layout: 'focus',
      transition: 't-fade',
      layoutTransition: 't-fade',
      systemBar: {
        color: 'neutral0',
      },
      layoutProps: {
        backButton: {
          to: from => `/u/${from.params.username}/collections/${from.params.id}`,
        },
      },
    },
  },
  {
    path: '/c/:shortId',
    component: () => import('@/views/PublicCollections/PublicCollectionShortId.vue'),
    meta: {
      requiresAuth: false,
      skipOnboarding: true,
      isPublicRoute: true,
      layout: 'fullscreen',
      transition: 't-fade',
      layoutTransition: 't-fade',
      systemBar: {
        color: 'neutral0',
      },
    },
  },
]
